import classNames from 'classnames';

import {ChevronLightRegularLeft} from 'shells/icon';

import {Button} from '../button/button';

import {getHeaderPrimaryButtonVariant} from './helpers';

import styles from './sidebar-header.module.css';

export type PrimaryButtonType = 'primary' | 'secondary';
type SecondaryButtonType = 'secondary' | 'chevron';

export type Props = {
    headerTitle: string;
    subtitle?: string;
    onClose: () => any;
    onSave?: () => any;
    primaryButton?: {
        type: PrimaryButtonType;
        label?: string;
        isLoadingLabel?: string;
        isLoading?: boolean;
        isDisabled?: boolean;
    };
    secondaryButton?: {
        type: SecondaryButtonType;
        label?: string;
    };
    // Used to get ref for button rendered when either onSave or submitButton
    // are passed - does nothing if both are missing.
    getButtonRef?: any;
    variant?: 'off-white' | 'white';
};

export function SidebarHeader(props: Props) {
    const variant = props.variant ?? 'off-white';
    const headerBarStyles = classNames(styles['header-bar'], {
        [styles['header-bar--white']]: variant === 'white',
    });
    const primaryButtonLabel = props.primaryButton?.label ? props.primaryButton.label : 'Save';
    const isLoadingLabel = props.primaryButton?.isLoadingLabel
        ? props.primaryButton.isLoadingLabel
        : 'Saving…';
    const secondaryButtonLabel = props.secondaryButton?.label
        ? props.secondaryButton.label
        : 'Cancel';

    return (
        <div className={headerBarStyles}>
            {props.secondaryButton ? (
                <div className={styles['close-button']}>
                    <Button variant='text-secondary' size='big' onClick={props.onClose}>
                        {props.secondaryButton.type !== 'chevron' ? (
                            secondaryButtonLabel
                        ) : (
                            <ChevronLightRegularLeft size={24} />
                        )}
                    </Button>
                </div>
            ) : undefined}
            <div className={styles['title-container']}>
                <h1>{props.headerTitle}</h1>
                <div className={styles['subtitle-container']}>{props.subtitle}</div>
            </div>
            {props.onSave || props.primaryButton ? (
                <div className={styles['save-button']}>
                    <Button
                        variant={
                            props.primaryButton
                                ? getHeaderPrimaryButtonVariant(props.primaryButton.type)
                                : 'text-primary'
                        }
                        size='big'
                        disabled={props.primaryButton?.isDisabled || props.primaryButton?.isLoading}
                        getButtonRef={props.getButtonRef}
                        type={props.primaryButton ? 'submit' : 'button'}
                        onClick={
                            !props.primaryButton?.isLoading && props.onSave
                                ? props.onSave
                                : undefined
                        }
                    >
                        {props.primaryButton?.isLoading ? isLoadingLabel : primaryButtonLabel}
                    </Button>
                </div>
            ) : undefined}
        </div>
    );
}
